import { useEffect, useState } from "react";
import { toast } from "sonner";
import Header from "../components/Header";
import PortalBack from "../components/PortalBack";
import api from "../lib/api";

export default function Opportunities() {
  const [ops, setOps] = useState([]);
  useEffect(() => { api.get("/list/opportunities").then((r) => setOps(r.data)); }, []);
  return (
    <div className="min-h-screen bg-obsidian text-ivory">
      <Header variant="list" active="list" />
      <section className="pt-28 pb-14 px-6 lg:px-10 max-w-6xl mx-auto">
        <PortalBack label="Back to Dashboard" />
        <p className="eyebrow mb-4 mt-8">Live in the Network</p>
        <h1 className="font-display text-3xl lg:text-5xl tracking-tight leading-tight max-w-3xl">WHERE THE LEVERAGE SITS RIGHT NOW</h1>
        <div className="mt-12 space-y-px bg-gold/20 border border-gold/20">
          {ops.map((o) => (
            <div key={o.id} data-testid={`opportunity-${o.id}`} className="bg-obsidian p-6 lg:p-8 flex flex-col sm:flex-row sm:items-center gap-5">
              <div className="sm:w-40 shrink-0">
                <p className="eyebrow !text-aqua !text-[0.55rem]">Leak · {o.leak}</p>
                <p className="eyebrow !text-[0.55rem] mt-1 text-ivory/40">{o.type}</p>
              </div>
              <div className="flex-1"><h3 className="font-headline text-xl">{o.title}</h3><p className="text-sm text-ivory/60 mt-1">{o.desc}</p></div>
              <button data-testid={`op-express-${o.id}`} onClick={() => toast.success("Interest logged — Lola will surface matched members.")}
                className="btn-lux bg-transparent text-gold hover:bg-gold hover:text-obsidian whitespace-nowrap">Express Interest</button>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
